<template>
    <div class="page">
        <transition name="fade-transition">
            <MyExamsComponent get-url="/exams/homeworks/results" />
        </transition>
    </div>
</template>

<script>
// @ is an alias to /src

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import MyExamsComponent from './MyExamsComponent.vue'

export default {
    name: "Courses",
    components: {
        MyExamsComponent
    },
    data(){
        return {
            
        }
    },
    computed: {
        ...GlobalComputed,
        
    },
    watch: {
        
    },
    methods: {
        ...GlobalMethods,
        
    },
    mounted(){
    }
};
</script>